@use 'styles/variables';

.Tooltip {
  position: absolute;
  z-index: variables.$ZToolTip;

  background: variables.$white;

  padding: 1rem;
  border-radius: 8px;
  font-size: 14px;

  box-shadow: 0 2px 6px rgb(0 0 0 / 15%);

  pointer-events: auto;
}

.FullWidthAndHeight {
  width: 100%;
  height: 100%;
}
